const EVENT_PREFIX = 'dt_askp_';

/**
 * Sends a tracking event to Google Analytics.
 * The event name will be prefixed with `ai_quickstart_`.
 * @param {string} eventName The name of the event.
 * @param {object} eventParams Optional parameters for the event.
 */
export function track(eventName, eventParams = {}) {
  const prefixedEventName = `${EVENT_PREFIX}${eventName}`;
  if (window.gtag) {
    window.gtag('event', prefixedEventName, eventParams);
  } else {
    console.log(
      `Analytics disabled: gtag not found. Event: ${prefixedEventName}`,
      eventParams,
    );
  }
}
